<script setup>
import {ref, watch, defineProps} from 'vue'
import QRCode from 'qrcode'

const props = defineProps({
  value: {
    type: String,
    default: '',
  },
})

const imageSource = ref(null)

const renderQrCode = async () => {
  if (!props.value) {
    imageSource.value = null

    return
  }

  try {
    imageSource.value = await QRCode.toDataURL(props.value, {width: 320, margin: 0})
  } catch {
    imageSource.value = null
  }
}

watch(() => props.value, renderQrCode, {immediate: true})
</script>

<template>
  <img v-if="imageSource" :src="imageSource" alt="Payment QR code" class="qr-code" />
</template>

<style lang="scss" scoped>
.qr-code {
  display: block;
  width: toRem(140);
  height: toRem(140);
}
</style>
